(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["staff-styling-article"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var thumbs = document.querySelectorAll('.styling-gallery__thumb');          
    var mainImg = document.getElementById('styling-gallery-main');
    if (!mainImg || !thumbs.length) return;                                     
    thumbs.forEach(function (thumb) {
      thumb.addEventListener('click', function () {                             
        mainImg.src = thumb.dataset.src;                                        
        thumbs.forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');                                       
      });                                                                       
    });
  });                                                                           
  
  } catch(e) { console.error(e); }
})();
})();
